import styled from '@emotion/styled'
import { wrap as withStyle } from 'utils/styles'
import { Button } from 'components/patterns'

export default withStyle(
  () => `
  margin-top: 20px;
`
)

export const StyledButton = styled(Button)`
  display: block;
  margin-top: 8px;
  font-size: 12px;
`
